// extracted by mini-css-extract-plugin
export default {"BranchInfoBarContainer":"BranchInfoBar-module__BranchInfoBarContainer--Bo51w","Box":"BranchInfoBar-module__Box--xWlKp"};